import React, { useCallback, useReducer, useState } from "react";
import { Button, CloseButton, Form, Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

const codes = [
  "EDUCATION",
  "ELDERLY_SUPPORT",
  "ENROLLMENT",
  "SINGLE_MOTHERS",
  "CHILD_CARE",
  "RELIGIOUS_OUTREACH",
  "DISASTER_RELIEF",
  "MENTAL_HEALTH"
];

const initialState = { name: "", code: "", description: "", active: true };
const formReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_FIELD":
      return { ...state, [action.name]: action.value };
    case "RESET":
      return initialState;
    default:
      return state;
  }
};

export const CreateNewPurposeModal = ({
  showAddModal,
  setShowAddModal,
  addDonationPurpose,
}) => {
  const [formData, dispatch] = useReducer(formReducer, initialState);
  const [submitting, setSubmitting] = useState(false);

  const handleClose = useCallback(() => {
    setShowAddModal(false);
    dispatch({ type: "RESET" });
  }, [setShowAddModal]);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    dispatch({ type: "UPDATE_FIELD", name, value });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.code || !formData.description) {
      toast.error("Please fill in all the required filleds");
      return;
    }

    try {
      setSubmitting(true);
      await addDonationPurpose(formData);
      handleClose();
    } catch (error) {
      console.error("Error adding new purpose:", error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={showAddModal} onHide={handleClose} keyboard={false} centered>
      <Modal.Header className="bg-body-tertiarydd border-0">
        <Modal.Title style={{ fontSize: 14 }} className="ps-2">
          Create donation credit purpose
        </Modal.Title>
        <CloseButton
          className="btn btn-circle btn-sm transition-base p-0"
          onClick={handleClose}
        />
      </Modal.Header>
      <Modal.Body className="px-4 py-0 pb-3">
        <Form className="p-0" onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              name="name"
              type="text"
              placeholder="e.g child care"
              required
              value={formData.name}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Code</Form.Label>
            <Form.Select
              size="sm"
              name="code"
              style={{ fontSize: "13.33px" }}
              required
              value={formData.code}
              onChange={handleChange}
            >
              <option value="">Select option</option>
              {codes.map((code) => (
                <option key={code} value={code}>
                  {code}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Brief description"
              name="description"
              required
              value={formData.description}
              onChange={handleChange}
            />
          </Form.Group>

          <div className="d-flex gap-2 mt-4">
            <Button
              size="md"
              variant="secondary"
              className="text-xs"
              onClick={() => setShowAddModal(false)}
            >
              Close
            </Button>
            {submitting ? (
              <Spinner animation="border" size="md" variant="success" />
            ) : (
              <Button
                size="md"
                variant="success"
                className="text-xs"
                type="submit"
              >
                Submit
              </Button>
            )}
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
